/* eslint-disable */
import React from 'react';
import axios from 'axios';
import API_BASE_URL from '../../api';
import Swal from 'sweetalert2';
import SlidingDrawer from '../../components/SlidingDrawer';

const ICONS = {
    add: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>,
    search: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>,
    calendar: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>,
    edit: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>,
    delete: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
};

const SessionManagement = () => {
    const [sessions, setSessions] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [filter, setFilter] = React.useState('');
    const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
    const [isEditing, setIsEditing] = React.useState(false);
    const [selectedSessionId, setSelectedSessionId] = React.useState(null);
    const [formData, setFormData] = React.useState({
        name: '',
        startDate: '',
        endDate: '',
        isActive: true
    });

    const token = localStorage.getItem('token');
    const api = axios.create({
        baseURL: `${API_BASE_URL}/api/admin`,
        headers: { Authorization: `Bearer ${token}` }
    });

    React.useEffect(() => {
        fetchSessions();
    }, []);

    const fetchSessions = async () => {
        setLoading(true);
        try {
            const res = await api.get('/sessions');
            setSessions(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            Swal.fire({
                title: isEditing ? 'Updating Session...' : 'Initializing Session...',
                didOpen: () => Swal.showLoading(),
                allowOutsideClick: false
            });

            if (isEditing) {
                await api.put(`/sessions/${selectedSessionId}`, formData);
            } else {
                await api.post('/sessions', formData);
            }

            Swal.fire({
                title: 'Success',
                text: isEditing ? 'Legislative session updated successfully.' : 'New session initialized successfully.',
                icon: 'success',
                confirmButtonColor: '#C0722C'
            });

            setIsDrawerOpen(false);
            setFormData({ name: '', startDate: '', endDate: '', isActive: true });
            setIsEditing(false);
            fetchSessions();
        } catch (err) {
            Swal.fire('Error', 'Failed to process session request.', 'error');
        }
    };

    const handleEdit = (session) => {
        setFormData({
            name: session.name,
            startDate: session.startDate.split('T')[0],
            endDate: session.endDate.split('T')[0],
            isActive: session.isActive
        });
        setSelectedSessionId(session._id);
        setIsEditing(true);
        setIsDrawerOpen(true);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Delete Session?',
            text: 'This will permanently remove this session from the registry.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D32F2F',
            cancelButtonColor: '#2C1A10',
            confirmButtonText: 'Yes, Delete'
        });

        if (result.isConfirmed) {
            try {
                await api.delete(`/sessions/${id}`);
                Swal.fire('Deleted', 'Session removed from registry.', 'success');
                fetchSessions();
            } catch (err) {
                Swal.fire('Error', 'Failed to delete session.', 'error');
            }
        }
    };

    const filteredSessions = sessions.filter(s =>
        s.name.toLowerCase().includes(filter.toLowerCase())
    );

    const InputField = ({ label, value, onChange, placeholder, type = "text", required = false, icon }) => (
        <div style={{ marginBottom: '25px' }}>
            <label style={{ display: 'block', fontSize: '11px', fontWeight: '800', color: '#888', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '10px' }}>
                {label} {required && <span style={{ color: '#C0722C' }}>*</span>}
            </label>
            <div style={{ position: 'relative' }}>
                {icon && (
                    <span style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#C0722C', display: 'flex' }}>
                        {icon}
                    </span>
                )}
                <input
                    type={type}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    required={required}
                    style={{
                        width: '100%',
                        padding: `16px 16px 16px ${icon ? '48px' : '16px'}`,
                        borderRadius: '16px',
                        border: '1px solid #E0E0E0',
                        fontSize: '15px',
                        color: '#2C1A10',
                        backgroundColor: '#F9F9F9',
                        boxSizing: 'border-box',
                        transition: 'all 0.3s ease'
                    }}
                    onFocus={(e) => { e.target.style.borderColor = '#C0722C'; e.target.style.backgroundColor = '#fff'; e.target.style.boxShadow = '0 0 0 4px rgba(192, 114, 44, 0.1)'; }}
                    onBlur={(e) => { e.target.style.borderColor = '#E0E0E0'; e.target.style.backgroundColor = '#F9F9F9'; e.target.style.boxShadow = 'none'; }}
                />
            </div>
        </div>
    );

    return (
        <div style={{ maxWidth: '1400px', margin: '0 auto', fontFamily: '"Outfit", sans-serif' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '35px' }}>
                <div>
                    <h1 style={{ margin: '0 0 8px 0', fontSize: '32px', fontWeight: '800', color: '#2C1A10' }}>Legislative Sessions</h1>
                    <p style={{ margin: 0, color: '#999', fontSize: '16px' }}>Define and manage active assembly periods for parliamentary business.</p>
                </div>
                <button
                    onClick={() => { setIsEditing(false); setFormData({ name: '', startDate: '', endDate: '', isActive: true }); setIsDrawerOpen(true); }}
                    style={{
                        padding: '16px 32px',
                        backgroundColor: '#2C1A10',
                        color: 'white',
                        border: 'none',
                        borderRadius: '20px',
                        fontWeight: '700',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        boxShadow: '0 10px 25px rgba(44, 26, 16, 0.2)',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                    onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                    {ICONS.add}
                    Initialize Session
                </button>
            </div>

            <div style={{ position: 'relative', marginBottom: '45px' }}>
                <div style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#C0722C', display: 'flex', zIndex: 2 }}>
                    {ICONS.search}
                </div>
                <input
                    type="text"
                    placeholder="Search sessions by name..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    style={{
                        width: '100%',
                        padding: '18px 20px 18px 48px',
                        borderRadius: '16px',
                        border: '1.5px solid #E5E5E5',
                        fontSize: '16px',
                        boxSizing: 'border-box',
                        outline: 'none',
                        transition: 'all 0.3s ease',
                        backgroundColor: '#FFF',
                        fontFamily: 'inherit',
                        color: '#333'
                    }}
                />
            </div>

            <div style={{ backgroundColor: 'white', borderRadius: '28px', boxShadow: '0 15px 45px rgba(0,0,0,0.03)', overflow: 'hidden', border: '1px solid #F0F0F0' }}>
                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', textAlign: 'left' }}>
                    <thead style={{ backgroundColor: '#FDF8F3' }}>
                        <tr style={{ color: '#888', fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
                            <th style={{ padding: '25px 30px' }}>Session Nomenclature</th>
                            <th style={{ padding: '25px 30px' }}>Duration Period</th>
                            <th style={{ padding: '25px 30px' }}>Active Status</th>
                            <th style={{ padding: '25px 30px', textAlign: 'right' }}>Directives</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="4" style={{ padding: '60px', textAlign: 'center', color: '#888', fontWeight: '600' }}>SYNCHRONIZING REPOSITORY...</td></tr>
                        ) : filteredSessions.length === 0 ? (
                            <tr>
                                <td colSpan="4" style={{ padding: '100px 40px', textAlign: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                                        <div style={{
                                            width: '120px',
                                            height: '120px',
                                            backgroundColor: '#FDF8F3',
                                            borderRadius: '45px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#C0722C',
                                            marginBottom: '30px'
                                        }}>
                                            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                                        </div>
                                        <h3 style={{ color: '#2C1A10', margin: '0 0 12px 0', fontSize: '24px', fontWeight: '800' }}>No Sessions Found</h3>
                                        <p style={{ color: '#888', fontSize: '16px', margin: 0, maxWidth: '350px', lineHeight: '1.6' }}>
                                            No legislative sessions found matching "<strong>{filter}</strong>".
                                        </p>
                                        <button
                                            onClick={() => setFilter('')}
                                            style={{
                                                marginTop: '35px',
                                                padding: '14px 28px',
                                                backgroundColor: 'transparent',
                                                border: '2px solid #C0722C',
                                                color: '#C0722C',
                                                borderRadius: '16px',
                                                fontWeight: '700',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Reset Registry Filter
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            filteredSessions.map(session => (
                                <tr key={session._id} style={{ borderBottom: '1px solid #F5F5F5', transition: 'background 0.2s' }}>
                                    <td style={{ padding: '25px 30px' }}>
                                        <div style={{ fontSize: '17px', fontWeight: '800', color: '#2C1A10' }}>{session.name}</div>
                                        <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>Legislative ID: {session._id.substring(0, 8)}...</div>
                                    </td>
                                    <td style={{ padding: '25px 30px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <div style={{ fontSize: '14px', color: '#666' }}>
                                                <div style={{ fontWeight: '700', color: '#C0722C', fontSize: '11px', textTransform: 'uppercase', marginBottom: '4px' }}>Commencement</div>
                                                {new Date(session.startDate).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
                                            </div>
                                            <div style={{ height: '30px', borderLeft: '1px dashed #DDD' }}></div>
                                            <div style={{ fontSize: '14px', color: '#666' }}>
                                                <div style={{ fontWeight: '700', color: '#C0722C', fontSize: '11px', textTransform: 'uppercase', marginBottom: '4px' }}>Closure</div>
                                                {new Date(session.endDate).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ padding: '25px 30px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: session.isActive ? '#2E7D32' : '#D32F2F', boxShadow: `0 0 10px ${session.isActive ? '#2E7D3280' : '#D32F2F80'}` }}></div>
                                            <span style={{ color: session.isActive ? '#2E7D32' : '#D32F2F', fontWeight: '800', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                                {session.isActive ? 'Active Assembly' : 'Terminated'}
                                            </span>
                                        </div>
                                    </td>
                                    <td style={{ padding: '25px 30px', textAlign: 'right' }}>
                                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                            <button
                                                onClick={() => handleEdit(session)}
                                                style={{
                                                    padding: '12px',
                                                    backgroundColor: '#FDF8F3',
                                                    color: '#C0722C',
                                                    border: '1px solid #F0E8DB',
                                                    borderRadius: '12px',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                                title="Edit Session"
                                            >
                                                {ICONS.edit}
                                            </button>
                                            <button
                                                onClick={() => handleDelete(session._id)}
                                                style={{
                                                    padding: '12px',
                                                    backgroundColor: '#FFF5F5',
                                                    color: '#E53935',
                                                    border: '1px solid #FFEBEE',
                                                    borderRadius: '12px',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                                title="Delete Session"
                                            >
                                                {ICONS.delete}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <SlidingDrawer
                isOpen={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                title={isEditing ? "Modify Legislative Registry" : "Initialize New Session"}
            >
                <form onSubmit={handleFormSubmit} style={{ padding: '10px 0' }}>
                    <InputField
                        label="Session Designation"
                        icon={ICONS.calendar}
                        value={formData.name}
                        onChange={(val) => setFormData({ ...formData, name: val })}
                        placeholder="e.g. Budget Session 2026"
                        required
                    />

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '10px' }}>
                        <InputField
                            label="Commencement Date"
                            type="date"
                            value={formData.startDate}
                            onChange={(val) => setFormData({ ...formData, startDate: val })}
                            required
                        />
                        <InputField
                            label="Closure Date"
                            type="date"
                            value={formData.endDate}
                            onChange={(val) => setFormData({ ...formData, endDate: val })}
                            required
                        />
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <label style={{ display: 'block', fontSize: '11px', fontWeight: '800', color: '#888', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '10px' }}>
                            Registry Status
                        </label>
                        <div
                            onClick={() => setFormData({ ...formData, isActive: !formData.isActive })}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                padding: '18px 24px',
                                borderRadius: '16px',
                                border: '1px solid #E0E0E0',
                                backgroundColor: formData.isActive ? '#F4FBF5' : '#FFF8F8',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <div style={{
                                width: '45px',
                                height: '24px',
                                backgroundColor: formData.isActive ? '#2E7D32' : '#BDBDBD',
                                borderRadius: '20px',
                                position: 'relative',
                                transition: 'all 0.3s'
                            }}>
                                <div style={{
                                    width: '18px',
                                    height: '18px',
                                    backgroundColor: 'white',
                                    borderRadius: '50%',
                                    position: 'absolute',
                                    top: '3px',
                                    left: formData.isActive ? '24px' : '3px',
                                    transition: 'all 0.3s'
                                }}></div>
                            </div>
                            <div>
                                <div style={{ fontSize: '14px', fontWeight: '800', color: formData.isActive ? '#2E7D32' : '#D32F2F' }}>
                                    {formData.isActive ? 'ACTIVE ASSEMBLY' : 'TERMINATED/ARCHIVED'}
                                </div>
                                <div style={{ fontSize: '12px', color: '#888' }}>Toggle to set session operational visibility.</div>
                            </div>
                        </div>
                    </div>

                    <div style={{ padding: '24px', backgroundColor: '#FDF8F3', borderRadius: '20px', border: '1px solid #F0E8DB', marginBottom: '35px', display: 'flex', gap: '15px' }}>
                        <div style={{ color: '#C0722C' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                        </div>
                        <div>
                            <div style={{ color: '#2C1A10', fontWeight: '800', fontSize: '14px', marginBottom: '5px' }}>Assembly Protocol</div>
                            <div style={{ color: '#888', fontSize: '13px', lineHeight: '1.5' }}>Ensure dates are accurate. Archiving a session will restrict creation of new agendas under its ID.</div>
                        </div>
                    </div>

                    <button
                        type="submit"
                        style={{
                            width: '100%',
                            padding: '18px',
                            backgroundColor: '#C0722C',
                            color: 'white',
                            border: 'none',
                            borderRadius: '16px',
                            fontWeight: '800',
                            fontSize: '16px',
                            cursor: 'pointer',
                            boxShadow: '0 10px 20px rgba(192, 114, 44, 0.2)',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#2C1A10'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#C0722C'; e.currentTarget.style.transform = 'translateY(0)'; }}
                    >
                        {isEditing ? 'Synchronize Registry Details' : 'Initialize Assembly Protocol'}
                    </button>
                </form>
            </SlidingDrawer>
        </div>
    );
};

export default SessionManagement;
